import { OCFE } from "@/assets/ocfe/index.js"
let ocfe = new OCFE()
let signalSdk = ocfe.initSignal()
let mediaSDK = ocfe.initMedia()

export { signalSdk, mediaSDK }
